var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isVisible)?_c('b-button',{staticClass:"f-110 go-top py-0",attrs:{"variant":"gray","aria-label":_vm.$t('맨 위로')},on:{"click":_vm.backToTop}},[_c('fa',{attrs:{"icon":"angle-up"}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }